import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import SendMessagesModal from '../../generics/components/SendMessagesModal';
import { sendMessagesAction } from '../../../../services/request';
import { useEmployees } from '../EmployessContext';
import EmailIcon from '@mui/icons-material/Email';

export default function EmployeesSendMessagesModal() {
  const { rows } = useEmployees();
  const [open, setOpen] = useState(false);

  return <Box
    sx={{ p: 3, width: '100%',
      display: 'flex',
      flexDirection: 'row' }}>
    <Button fullWidth variant = "contained" endIcon={<EmailIcon />} onClick={() => setOpen(true)}>Wyślij wiadomości</Button>
    {open ? <SendMessagesModal rows={rows} sendMessages={sendMessagesAction} setOpen={setOpen} type="employees"/> : null}
  </Box>;
}
